import { render, staticRenderFns } from "./DetailProjectActivities.vue?vue&type=template&id=7f84ecbe"
import script from "./DetailProjectActivities.vue?vue&type=script&lang=js"
export * from "./DetailProjectActivities.vue?vue&type=script&lang=js"
import style0 from "./DetailProjectActivities.vue?vue&type=style&index=0&id=7f84ecbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports